import type { CheckinStorage } from '@awwyeah/shared';
import { checkinStorageSchema } from '@awwyeah/shared';

/**
 * `GET /api/checkin/storage` for the archive's storage line. Zod-validated like every
 * boundary, and null-on-failure rather than throwing: the archive is fully readable
 * offline, it just can't say how much room it's taking.
 */
export async function fetchCheckinStorage(): Promise<CheckinStorage | null> {
  try {
    const response = await fetch('/api/checkin/storage', { credentials: 'include' });
    if (!response.ok) return null;
    const parsed = checkinStorageSchema.safeParse(await response.json());
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
